import React, { useEffect, useRef, useState } from "react";
import { Link, useLocation, useNavigate, Navigate } from "react-router-dom";
import { tCell, Button, GenericTable, ActionMenu, DetailCard, Dialog } from "../utils";
import { useDevices, useUserPermissions, useUserDetail, useOrgs, useTcpClients, usePlant } from "../../services/hooks";
import theme, { buttonClasses } from "../utils/theme";
import { capitalizeCamelCase, debounce, isObjectEqual } from "../../services/functions";
import Genericfilter from "../utils/Genericfilter";
import { GenericstatsV2 } from "../utils/Genericstats";
import { useDeviceContext } from "../../context/socketContext";
import CommonTour, { TourIcon } from "../Tour/CommonTour";
import { usePlantContext } from "../../context/plantContext";
import SendCommand from "./SendCommand";
import dayjs from "dayjs";
import ViewTelemetry from "./ViewTelemetry";
import { Tooltip } from "@mui/material";
import { InfoIcon } from "../../services/icons";
const dummyTourData = [
	{
		antenna: [
			{
				antennanumber: "",
				status: "",
				action: "",
			},
		],
		characterEncoding: "utf-8",
		commandIndex: 0,
		creation_date: "2025-05-05T06:05:02.696Z",
		dataSeparator: "",
		deviceSubType: "",
		deviceType: "speaker",
		displayName: "Digital Sound System",
		endSeparator: "",
		imei: "XXXXXXXX",
		ledMsgType: "",
		ledStaticMsg: "",
		logPattern: [
			{
				commandCode: "",
				logTime: 0,
				"": "",
			},
		],
		modified_on: "2025-05-05T06:05:02.696Z",
		module: "VMS",
		orgId: "65fbd1a953312156626a627e",
		power: "",
		project: "LYNKID",
		proximityMode: false,
		startSeparator: "",
		tidPattern: "",
		valueConfig: {
			"": "",
		},
		__v: 0,
		_id: "6818550e4328e635f7d5073f",
	},
];
const defaultFilter = {
	pagesize: 10,
	page_no: 1,
};
const deviceTypeOptions = [
	{ value: "rfid", label: "RFID Reader" },
	{ value: "led", label: "LED" },
	{ value: "speaker", label: "Speaker" },
	{ value: "camera", label: "Camera" },
	{ label: "Workstation", value: "workstation" },
];
const DeviceManagementTour = [
	{
		target: ".title",
		content: "Welcome to Device Management! Here you can view, add, and manage all your connected devices.",
		placement: "bottom",
	},
	{
		target: ".a_tag_no",
		content: "Click here to add a new device to your system.",
		placement: "left",
	},
	{
		target: ".genericStats-containter",
		content: "These statistics cards show key metrics about device activities.",
		placement: "bottom",
	},
	{
		target: "#Genericfilter",
		content: "Use these filters to search for specific devices by ID, name, or organization.",
		placement: "bottom",
	},
	{
		target: ".main_content",
		content: "This table lists all your devices with their key information. Click on device names to view details.",
		placement: "top",
	},
	{
		target: ".deviceStatus",
		content: "This indicator shows whether a device is currently connected (green) or disconnected (red).",
		placement: "right",
	},
	{
		target: ".displayName",
		content: "Click on the device name to see the details of that particular device.",
		placement: "bottom",
		action: async () => {
			const firstDeviceName = document.querySelector("displayName") || document.querySelector('[class*="displayName"]');
			if (firstDeviceName) {
				firstDeviceName.click();
				await waitForElement(".detail_card", 2000);
			}
		},
	},
	{
		target: ".detail_card",
		content: "When viewing device details, you'll see comprehensive information including configuration and antenna details.",
		placement: "left",
		condition: () => document.querySelector(".detail_card") !== null,
	},
	{
		target: ".actionMenu",
		content: "Use these action buttons to view details, edit settings, duplicate, or manage device logs.",
		placement: "left",
	},
];
function waitForElement(selector, timeout = 1000) {
	return new Promise((resolve, reject) => {
		const start = Date.now();
		const check = () => {
			const el = document.querySelector(selector);
			if (el) {
				resolve(el);
			} else if (Date.now() - start >= timeout) {
				reject(new Error(`Element ${selector} not found within ${timeout}ms`));
			} else {
				setTimeout(check, 100);
			}
		};
		check();
	});
}
const nestedHeaders = {
	logPattern: ["Command Code", "Log Time", "Key", "Value"],
	antenna: ["Antenna Number", "Status", "Action"],
	valueConfig: ["Key", "Value"],
};

function createDeviceDetailData(data) {
	let dataToShow;
	if (data["deviceType"] == "led") {
		dataToShow = ["displayName", "imei", "deviceType", "ledMsgType", "ledStaticMsg", "characterEncoding"];
	} else if (data.deviceType == "speaker") {
		dataToShow = ["displayName", "imei", "deviceType", "characterEncoding"];
	} else {
		dataToShow = ["displayName", "tidPattern", "startSeparator", "endSeparator", "dataSeparator", "commandIndex", "power", "imei", "logPattern", "valueConfig", "antenna", "characterEncoding"];
	}

	// console.log({ data });

	const result = (
		<>
			{dataToShow.map((key, i) => {
				if (["logPattern", "antenna"].includes(key)) {
					// console.log(key, data[key]);
					let items = [];
					for (let item of data[key]) {
						// console.log({ item });

						let row = [];
						for (let key in item) {
							row.push(
								<div className="detail_inner_row" key={i + key}>
									<div>{capitalizeCamelCase(key)} : </div>
									<div>{item[key]}</div>
								</div>
							);
						}

						items.push(
							<div className="device_detail_nest_wrap" key={i + key}>
								<div style={{ fontWeight: "bold" }}>{capitalizeCamelCase(key)} :</div>
								<div className="device_inner_row_wrap">{row}</div>
							</div>
						);
					}
					// console.log(items);
					return (
						<div className="device_nested_wrap" key={i}>
							{items}
						</div>
					);
				}
				if (key == "valueConfig") {
					let row = [];
					for (let item in data[key]) {
						row.push(
							<div className="detail_inner_row" key={i + key}>
								<div>{capitalizeCamelCase(item)} : </div>
								<div>{data[key][item]}</div>
							</div>
						);
					}

					return (
						<div className="device_nested_wrap" key={i}>
							<div className="device_detail_nest_wrap">
								<div style={{ fontWeight: "bold" }}>{capitalizeCamelCase(key)} :</div>
								<div className="device_inner_row_wrap">{row}</div>
							</div>
						</div>
					);
				}
				return (
					<div className="detail_row" key={i}>
						<div className="detail_row_title">{capitalizeCamelCase(key)}</div>
						<div className="detail_row_value">{data[key]}</div>
					</div>
				);
			})}
		</>
	);

	return result;

	// console.log({ result });
}
const DeviceManagement = () => {
	const navigate = useNavigate();
	const { userPermissions, isFetched } = useUserPermissions();
	const location = useLocation();
	const { filterData } = location.state || {};
	// console.log("RECEIVING DATA FROM THE FILTERDATA", filterData)
	const { userDetail, isSuperAdmin } = useUserDetail();
	const { plantId } = usePlantContext();
	const filterRef = useRef(defaultFilter);
	if (filterData) filterRef.current = { ...filterRef.current, ...filterData };
	if (userDetail.userType !== "superAdmin") {
		filterRef.current.plantIds = plantId;
	}
	// Using this useEffect to resolve the issue of page refresh state.
	// The problem was: when we refreshed the page and currentFilters existed, the filters were not being cleared.
	useEffect(() => {
		navigate(".", { replace: true });
	}, [navigate]);
	const { page_no, pagesize } = filterRef.current;
	const { devices, count, isLoading, getDevices } = useDevices(userDetail.userType === "superAdmin" ? filterRef.current : null);
	const [isOpen, setIsOpen] = useState(false);
	const [detail, setDetail] = useState(null);
	const [isModal, setIsModal] = useState(false);
	const [isTelemetryModal, setIsTelemetryModal] = useState(false)
	const [telemetryData, setTelemetryData] = useState("")
	const updateDataRef = useRef(null);
	const shouldHandlePlant = userDetail?.userType == "superAdmin" || userPermissions?.managePlant?.value;
	useEffect(() => {
		if (filterData?.orgId && userDetail?.userType == "superAdmin") {
			getPlantDetails({ orgId: filterData.orgId });
		}
	}, [filterData]);

	const tourRef = useRef();
	const [isTourMode, setIsTourMode] = useState(false);
	const shouldRunTour = !userDetail?.moduleTour?.devices;
	const { orgOptions } = useOrgs();
	const { plantOptions, getPlantDetails, clearPlants } = usePlant();

	const { deviceData } = useDeviceContext();
	const { tcpClients, getTcpClients } = useTcpClients();
	useEffect(() => {
		if (filterRef.current && userDetail?.userType !== "superAdmin") {
			getDevices(filterRef.current);
		}
	}, [plantId]);
	// IF SOCKET EVENT DOES NOT WORKS PROPERLY.... THEN IN THIS CASE CALLING GETDEVICES AFTER EVERY 90 SECS
	useEffect(() => {
		if (!filterRef.current) return;
		// getDevices(filterRef.current);
		getTcpClients({...filterRef.current, pagesize:500});
		const intervalId = setInterval(() => {
			// getDevices(filterRef.current);
			getTcpClients({...filterRef.current, pagesize:500});
		}, 90000);
		return () => clearInterval(intervalId);
	}, []);
	const filterFields = [
		{
			inputType: "textfield",
			id: "deviceUniqueID",
			name: "imei",
			type: "text",
			label: "Device Unique ID",
			placeholder: "Device Unique ID",
			readOnly: false,
			error: "",
			value: filterRef.current?.imei || "",
		},
		{
			inputType: "textfield",
			id: "deviceName",
			name: "displayName",
			type: "text",
			label: "Device Name",
			placeholder: "Device Name",
			readOnly: false,
			error: "",
			value: filterRef.current?.displayName || "",
		},
		...(userDetail?.userType === "superAdmin"
			? [
					{
						inputType: "dropdown",
						id: "orgId",
						name: "orgId",
						label: "Organization",
						error: "",
						option: orgOptions,
						value: filterRef.current?.orgId,
					},
			  ]
			: []),
		...(shouldHandlePlant && userDetail?.userType === "superAdmin"
			? [
					{
						inputType: "dropdown",
						id: "plantIds",
						name: "plantIds",
						label: "Warehouse",
						error: "",
						option: plantOptions,
						value: filterRef.current?.plantIds,
					},
			  ]
			: []),
		{
			inputType: "dropdown",
			id: "deviceType",
			name: "deviceType",
			label: "Device Type",
			error: "",
			option: deviceTypeOptions,
			value: filterRef.current?.deviceType,
		},
		...(userDetail?.userType === "superAdmin"
			? [
				{
					inputType: "textfield",
					id: "hardwareType",
					name: "hardwareType",
					label: "Hardware Type",
					placeholder: "Hardware Type",
					type: "text",
					readOnly: false,
					error: "",
					value: filterRef.current?.hardwareType || "",
				},
			]
			: []),
	];
	const handleDetailClose = () => {
		setIsOpen(false);
		setDetail(null);
	};

	const handleDeviceView = (e, index) => {
		// console.log(index, "view", devices[index], index);
		setDetail(shouldRunTour || isTourMode ? createDeviceDetailData(dummyTourData[0]) : createDeviceDetailData(devices[index == undefined ? e : index]));
		// setDetail(createDeviceDetailData(devices[index == undefined ? e : index] || dummyTourData[0]));
		setIsOpen(true);
	};

	const handleViewLogs = (index) => {
		if (index == undefined || !devices[index] || devices[index].imei == undefined) return;
		navigate("/devices/logs", { state: { deviceId: devices[index].imei } });
	};
	let header = ["S.no", "Device Name", "Status", "Device Type", "IMEI / Mac", "Last Active"];
	if (isSuperAdmin) {
		header.splice(1, 0, "Warehouse");
		header.splice(5, 0, "Hardware Type");
		header.splice(7, 0, "Serial No.");
	}
	// if permission
	//TODO device detail permission
	header.push("Actions");
	// if (userPermissions?.updateDevice?.value || userPermissions?.deleteDevice?.value) {
	// }

	const actionHandlers = {
		view: handleDeviceView,
	};
	if (userPermissions?.updateDevice?.value) {
		actionHandlers.edit = (i) => {
			// console.log(i, "edit");
			navigate("/devices/edit-device", { state: { data: devices[i], filterData: filterRef.current } });
		};
	}
	if (userPermissions?.addDevice?.value) {
		actionHandlers.duplicate = (i) => {
			navigate("/devices/add-device", { state: { data: devices[i], filterData: filterRef.current } });
		};
	}
	if (userPermissions?.deleteDevice?.value) {
		// actionHandlers.delete = (id) => {
		// 	console.log(id, "delete");
		// };
	}
	if (userPermissions?.viewTelemetry?.value || isSuperAdmin) {
		actionHandlers.viewTelemetry =(i) =>{
			// console.log("i", i)
			setIsTelemetryModal(true)
			setTelemetryData(devices[i])
		}
	}

	//EXPLAINATION OF THE COLOR LOGIC
	// WHEN THE USER HIERARCHY IS ZERO THEN WE HAVE TO SHOW THREE COLORS I.E. RED, YELLOW AND GREEN
	// THESE THREE COLORS WILL BE DECIDED ON THE BASIS OF THE FOLLOWING .....
	// 1. IF STATUS DEVICESTATUS IS TRUE && STATE IS WEAK >>>>> YELLOW COLOR WITH TOOLTIP
	// 2. IF THE DEVICESTATUS ID TRUE >> GREEN 
	// ELSE RED
	// IF USER HIERARCHY IS NOT ZERO THEN SIMPLY GREEN AND RED ON THE BASIS OF THE DEVICESTATUS
	const rows = (shouldRunTour || isTourMode ? dummyTourData : devices)?.map((d, i) => {
		let row = [];
		// console.log(" deviceData[d.imei]" , deviceData)
		let d_info = deviceData[d.imei] != undefined ? deviceData[d.imei] : tcpClients[d.imei]; // deviceData.find((_) => _.deviceId == d.imei);
		// console.log('d_info', d_info)
		row.push(
            tCell((page_no - 1) * pagesize + i + 1),
            tCell(d?.Displayname || d?.displayName, theme.themeOrange, "pointer", handleDeviceView, i, "displayName"),
            ...(userDetail?.userRoleHierarchy == 0
                ? d.deviceType !== "speaker"
                    ? [
                          tCell(
                              <div className="statusTooltipWrapper">
                                  {deviceData[d.imei]?.state?.toLowerCase() === "weak" ? (
                                      <>
                                          <span className="deviceStatus weakStatus"></span>
                                          <div className="statusTooltipBox">{deviceData[d.imei]?.info || d_info|| "No info available"}</div>
                                      </>
                                  ) : (
                                      // GREEN DOT (CONNECTED)
                                      <span className={`deviceStatus ${deviceData[d.imei]?.deviceStatus === true || d_info? "connected" : ""}`}></span>
                                  )}
                              </div>
                          ),
                      ]
                    : " "
                : d.deviceType !== "speaker"
                ? [tCell(<span className={`deviceStatus ${deviceData[d.imei]?.deviceStatus === true ? "connected" : ""}`}></span>)]
                : " "),

            tCell(`${capitalizeCamelCase(d.deviceType)} ${d.deviceSubType ? `(${d.deviceSubType})` : ""}`),
            tCell(d?.imei),
            ...(d.deviceType !== "speaker" ? [tCell(<span>{d_info ? "-" : d.lastActive ? dayjs(d.lastActive).format("DD MMM YYYY, hh:mm A") : "-"}</span>)] : "-")
        );
		if (isSuperAdmin) {
			row.splice(1, 0, tCell(d?.plantName));
			row.splice(5, 0, tCell(d.hardwareType));
			row.splice(7, 0, tCell(d?.serialNo));
		}
		//TODO device detail permission
		let _actionHandlers = { ...actionHandlers };
		if (userPermissions?.sendCommand?.value) {
			const includeSendCommand = (d.deviceType === "led" && d.deviceSubType === "TWOLINE") || (d.deviceType === "rfidReader" && d.deviceSubType === "seuic") || (d.deviceType === "rfidReader" && d.deviceSubType === "customReader");
			if (includeSendCommand) {
				_actionHandlers.sendCommand = () => {
					setIsModal(true);
					updateDataRef.current = d;
				};
			}
		}
		row.push(<ActionMenu id={i} handlers={_actionHandlers} />);
		return row;
	});

	const onPageChange = (page_no) => {
		filterRef.current = { ...filterRef.current, page_no: page_no + 1 };
		getDevices(filterRef.current);
	};
	const onPageSizeChange = (e) => {
		const { value } = e.target;
		filterRef.current = { ...filterRef.current, pagesize: value };
		getDevices(filterRef.current);
	};
	const onModalClose = () => {
		setIsModal(false);
		if (updateDataRef.current) {
			updateDataRef.current = null;
		}
	};
	const onTelemetryClose = () => {
		setIsTelemetryModal(false)
	};
	/**
	 * We use GenericFilter component for all CRUD filters. That component maintains its own state for the filter
	 * and that object is sent here to the handleFilterChange function.
	 * Mutating this _filter object will cause the filter state to change on rerender (It's probably because of object reference in JS. The filter object from the state gets mutated and then the component gets re-rendered  due to any reason and now the state will have the mutated object)
	 * Here we have relationship between Org and Plant. On selecting an org, we will fetch its plant. So in order to clear previous selected plant when selecting different org, we will mutate the _filter object
	 */
	const handleFilterChange = (_filter) => {
		let filter = { ..._filter };
		for (let key in filter) {
			if (!filter[key]) delete filter[key];
		}
		if (filter.orgId) {
			if (shouldHandlePlant && filter.orgId != filterRef.current.orgId) {
				//
				// when switching organization, we want to
				// - get plants for that org
				// - clear plantIds from the local filter object
				// - clear plantIds from original filter object, mutating the state and clearing the plant dropdown
				delete filter.plantIds;
				delete _filter.plantIds;
				getPlantDetails({ orgId: filter.orgId });
			}
		} else {
			delete filter.plantIds;
			clearPlants();
		}

		filter.page_no = 1;
		filter.pagesize = 10;
		if (!isObjectEqual(filterRef.current, filter)) {
			filterRef.current = { ...filter };
			getDevices(filterRef.current);
		}
	};

	if (isFetched && userPermissions && Object.keys(userPermissions).length && !userPermissions.getDevice?.value) return <Navigate to="/not-authorized" replace />;
	const handleTourStart = () => {
		setIsTourMode(true);
		tourRef.current?.restartTour();
	};
	const handleAddDevice = () => {
		navigate("/devices/add-device", { state: { filterData: filterRef.current } });
	};
	return (
		<div className="contentpanel">
			<CommonTour
				ref={tourRef}
				steps={DeviceManagementTour}
				moduleName="devices"
				onTourComplete={() => {
					setIsTourMode(false);
					handleDetailClose();
				}}
			/>
			<div className="cust-row flex-algn-cent">
				<div className="cust-col-5">
					<h1 className="title">
						Device Management
						<span title="Replay Tour" onClick={handleTourStart} style={{ cursor: "pointer" }}>
							<TourIcon />
						</span>
					</h1>
				</div>
				{userPermissions?.addDevice?.value ? (
					<div className="cust-col-5 flex-jc-end">
						<div>
							<Button text="Add Device" style={buttonClasses.lynkitOrangeEmpty} onClick={handleAddDevice} />
						</div>
					</div>
				) : null}
			</div>
			<hr className="bgg" />
			<GenericstatsV2 statsFor={"devices"} plantId={plantId} />
			<Genericfilter filterFields={filterFields} onFilterChange={debounce((filter) => handleFilterChange(filter), 500)} addOnClear/>
			<div className="main_content">
				<GenericTable
					header={header}
					rows={rows}
					pageCount={count}
					pageNo={filterRef.current.page_no}
					limit={filterRef.current.pagesize}
					onPageChange={onPageChange}
					onPageSizeChange={onPageSizeChange}
					isLoading={isLoading}
				/>

				<DetailCard isOpen={isOpen} onClose={handleDetailClose} title={"Device Details"}>
					{detail}
				</DetailCard>
			</div>
			{isModal && <SendCommand onClose={onModalClose} open={isModal} deviceData={updateDataRef.current} />}
			{isTelemetryModal &&<ViewTelemetry size="lg" open={isTelemetryModal} onClose={onTelemetryClose} title={`${telemetryData?.displayName} ( ${telemetryData?.imei} )`} deviceData={telemetryData}/>}
		</div>
	);
};

export default DeviceManagement;
